import React, { useState } from "react";
import { HiOutlineLocationMarker, HiOutlineTicket } from "react-icons/hi"; // Import icons from react-icons library
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import LoadingScreen from './LoadingScreen'; // Import the LoadingScreen component


export default function SearchBox() {
    const [submitting, setSubmitting] = useState(false); // State variable to track form submission

    const navigate = useNavigate();

    const [tripInfo, setTripInfo] = useState({
        destination: '',
        numberOfDays: '', // Changed from 'totalDays'
        preferences: ''
    });

    const [errors, setErrors] = useState({
        destination: '',
        numberOfDays: '', // Changed from 'totalDays'
        preferences: ''
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setTripInfo({ ...tripInfo, [name]: value });
        setErrors({ ...errors, [name]: '' }); // Clear any previous errors when the input changes
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSubmitting(true); // Set submitting state to true when form is submitted

        // Validate form inputs
        const { destination, numberOfDays, preferences } = tripInfo;
        const newErrors = {};

        if (!destination.trim()) {
            newErrors.destination = 'Destination is required';
        }

        if (!numberOfDays.trim()) {
            newErrors.numberOfDays = 'Number of days is required';
        }

        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            setSubmitting(false); // Set submitting state back to false if there are errors
            return; // Stop form submission if there are errors
        }

        const formData = {
            destination,
            totalDays: numberOfDays, // Changed from 'totalDays'
            preferences
        };
        console.log('Form data:', formData);
        try {
            // Send data to backend
            const response = await axios.post('https://jetsetai-server.vercel.app/api/generate-itinerary', formData);
            console.log('Response from backend:', response.data);
            navigate('/itinerary', { state: { state: response.data } });

            // Optionally, you can reset the form here if needed
            setTripInfo({
                destination: '',
                numberOfDays: '', // Changed from 'totalDays'
                preferences: ''
            });
        } catch (error) {
            console.error('Error sending data to backend:', error);
            // Handle error, display error message to the user, etc.
        } finally {
            setSubmitting(false); // Set submitting state back to false after navigation
        }
    };


  return (
    <div className="flex flex-col lg:flex-row items-center bg-white/20 justify-between p-6 sm:p-8 lg:p-8 mx-auto rounded-lg h-auto lg:h-24 w-full max-w-4xl relative z-10">
    {submitting && <LoadingScreen />}
    <form className="flex flex-col lg:flex-row justify-between w-full" onSubmit={handleSubmit}>
        <div className="flex flex-col relative mb-4 lg:mb-0 lg:mr-6 w-full lg:w-auto">
            <HiOutlineLocationMarker className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-500" />
            <input
                type="text"
                name="destination"
                id="destination"
                onChange={handleChange}
                className="block rounded-lg pl-10 pr-4 py-2 w-full lg:w-72 text-sm text-gray-900 bg-gray-50 border-b-2 border-gray-300 focus:outline-none focus:ring-0 focus:border-blue-600"
                placeholder="Destination"
            />
            {errors.destination && <p className="text-red-500 text-sm mt-1">{errors.destination}</p>}
        </div>
        <div className="flex flex-col mb-4 lg:mb-0 lg:mr-6 w-full lg:w-auto">
            <select
                name="numberOfDays"
                onChange={handleChange}
                className="block px-4 py-2 w-full lg:w-36 text-sm text-gray-500 bg-gray-50 rounded-lg border-b-2 border-gray-300 focus:outline-none focus:ring-0 focus:border-blue-600"
            >
                <option value="">Number of Days</option>
                <option value="1">1 Day</option>
                <option value="2">2 Days</option>
                <option value="3">3 Days</option>
                <option value="4">4 Days</option>
                <option value="5">5 Days</option>
                <option value="6">6 Days</option>
                <option value="7">7 Days</option>
            </select>
            {errors.numberOfDays && <p className="text-red-500 text-sm mt-1">{errors.numberOfDays}</p>}
        </div>
        <div className="flex flex-col relative mb-4 lg:mb-0 lg:mr-6 w-full lg:w-auto">
            <HiOutlineTicket className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-500" />
            <input
                type="text"
                name="preferences"
                id="preferences"
                onChange={handleChange}
                className="block rounded-lg pl-10 pr-4 py-2 w-full lg:w-56 text-sm text-gray-900 bg-gray-50 border-b-2 border-gray-300 focus:outline-none focus:ring-0 focus:border-blue-600"
                placeholder="Trip Preferences"
            />
            {errors.preferences && <p className="text-red-500 text-sm mt-1">{errors.preferences}</p>}
        </div>
        <button
            type="submit"
            className="bg-blue-600 text-white w-full lg:w-40 py-2 rounded-md hover:bg-blue-500"
        >
            Plan My Trip
        </button>
    </form>
</div>
  );
}
